import { render } from "./lin-icon.vue?vue&type=template&id=4ea1220b&scoped=true"
import script from "./lin-icon.vue?vue&type=script&lang=js"
export * from "./lin-icon.vue?vue&type=script&lang=js"

import "./lin-icon.vue?vue&type=style&index=0&id=4ea1220b&lang=scss&scoped=true"

import exportComponent from "D:\\Liyg\\jzwork\\view\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea1220b"]])

export default __exports__